import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import { formFlowAtom } from "./Atom/formFlowAtom";

interface SelectDetailedGenreType {
  detailedGenre: string;
}

const genreOptions: Record<string, { label: string; value: string }[]> = {
  article: [
    { label: "분석 기사", value: "analysis_report" },
    { label: "인터뷰 기사", value: "interview" },
    { label: "사설/칼럼", value: "editorial" },
    { label: "리뷰 기사", value: "review" },
  ],
  report: [
    { label: "연구 보고서", value: "research_report" },
    { label: "시장 조사 보고서", value: "market_research" },
    { label: "회사 보고서", value: "corporate_report" },
    { label: "기술 보고서", value: "technical_report" },
    { label: "환경 보고서", value: "environmental_report" },
  ],
  essay: [
    { label: "개인적 에세이", value: "personal_essay" },
    { label: "서사적 에세이", value: "narrative_essay" },
    { label: "비평적 에세이", value: "critical_essay" },
    { label: "철학적 에세이", value: "philosophical_essay" },
    { label: "여행 에세이", value: "travel_essay" },
  ],
  letter: [
    { label: "비즈니스 편지", value: "business_letter" },
    { label: "사적인 편지", value: "personal_letter" },
    { label: "감사 편지", value: "thank_you_letter" },
    { label: "요청 편지", value: "request_letter" },
    { label: "항의 편지", value: "complaint_letter" },
  ],
  novel: [
    { label: "판타지 소설", value: "fantasy" },
    { label: "공상과학 소설", value: "science_fiction" },
    { label: "미스터리 소설", value: "mystery_thriller" },
    { label: "로맨스 소설", value: "romance" },
    { label: "역사 소설", value: "historical_fiction" },
  ],
  poem: [
    { label: "서정시", value: "lyric_poetry" },
    { label: "서사시", value: "epic_poetry" },
    { label: "자유시", value: "free_verse" },
    { label: "사랑시", value: "romantic_poetry" },
    { label: "풍자시", value: "satirical_poetry" },
  ],
  play: [
    { label: "비극", value: "tragedy" },
    { label: "희극", value: "comedy" },
    { label: "역사극", value: "historical_drama" },
    { label: "현대극", value: "modern_drama" },
  ],
  fairy_tale: [
    { label: "교훈적 동화", value: "moral_stories" },
    { label: "판타지 동화", value: "fantasy_tales" },
    { label: "동물 동화", value: "animal_stories" },
  ],
  prose: [
    { label: "비평적 수필", value: "critical_essay" },
    { label: "개인적 수필", value: "personal_prose" },
  ],
  biography: [
    { label: "인물의 삶과 업적", value: "life_and_achievements" },
    { label: "특정 시대적 배경", value: "historical_background" },
  ],
  scenario: [
    { label: "영화", value: "movie_script" },
    { label: "드라마", value: "drama_script" },
    { label: "웹드라마", value: "web_drama" },
  ],
};

const SelectDetailedGenreForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SelectDetailedGenreType>({
    defaultValues: {
      detailedGenre: "",
    },
  });

  const [detailInfo, setDetailInfo] = useRecoilState(writingDetailInfoAtom);
  const [flow, setFlow] = useRecoilState(formFlowAtom);

  const onValid = (data: SelectDetailedGenreType) => {
    console.log("Selected Detailed Genre:", data.detailedGenre);
    setDetailInfo({ ...detailInfo, detailedGenre: data.detailedGenre });
    setFlow(3);
  };

  const onInvalid = (errors: any) => {
    console.log("Errors:", errors);
  };

  return (
    <div>
      <div className="text-xl font-bold mb-4">세부 장르를 선택하세요</div>
      <form onSubmit={handleSubmit(onValid, onInvalid)}>
        {/* 장르 선택 */}
        <div className="mb-4">
          <label
            htmlFor="detailedGenre"
            className="block text-gray-500 font-medium"
          >
            세부장르
          </label>
          <select
            id="detailedGenre"
            {...register("detailedGenre", {
              required: "세부 장르를 선택해주세요!",
            })}
            className="block w-full mt-2 p-2 border border-gray-300 dark:bg-slate-600 rounded-lg"
          >
            <option value="">{`--${detailInfo.genre} 세부 장르를 선택하세요--`}</option>
            {detailInfo.genre &&
              genreOptions[detailInfo.genre]?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
          {errors.detailedGenre && (
            <p className="text-red-500 mt-2">{errors.detailedGenre.message}</p>
          )}
        </div>

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          다음
        </button>
      </form>
    </div>
  );
};

export default SelectDetailedGenreForm;
